import { api } from '../api.js';

let cachedDeployment = null;

/**
 * 读取部署上下文（单/多租户、客户名、默认农场等）
 */
export const fetchDeploymentContext = async () => {
  const response = await api.get('/deployment/context');
  const data = response?.data?.data;
  if (data) {
    cachedDeployment = data;
    try {
      localStorage.setItem('deploymentContext', JSON.stringify(data));
    } catch (e) {
      /* ignore */
    }
  }
  return data;
};

export const getCachedDeploymentContext = () => {
  if (cachedDeployment) return cachedDeployment;
  try {
    const raw = localStorage.getItem('deploymentContext');
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};
